import React from 'react'
import { Text, View } from '@react-pdf/renderer'

const InfoLine = ({ label, value }) => {
  const isMultiline = typeof value === 'string' && value.includes('\n')
  if (!value) return null
  return (
    <View
      style={{
        flexDirection: isMultiline ? 'column' : 'row',
        gap: 8,
        fontSize: 10,
        paddingHorizontal: 5,
        paddingVertical: 2,
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        // width: '100%',
      }}
    >
      <Text>
        <Text style={{ fontFamily: 'Helvetica-Bold', marginRight: 4 }}>
          {label}:
        </Text>{' '}
        {value}
      </Text>
    </View>
  )
}

export default InfoLine
